<template>
  <b-card>
    <b-row>
      <div>
        frontend: <b>{{ frontendVersion.version }}</b>
      </div>
    </b-row>
    <b-row>
      <div>
        backend: <b>{{ backendVersion }}</b>
      </div>
    </b-row>
    <b-row>
      <b-button variant="danger" class="mr-1" @click="onBackPage">
        Voltar
      </b-button>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BButton } from "bootstrap-vue";
import { ref } from "@vue/composition-api";
import versionService from "@/providers/versionService";
import router from "@/router";
import AppConstants from "@/appConstants";
export default {
  components: {
    BCard,
    BRow,
    BButton
  },
  created() {
    this.getBackendVersion();
  },
  setup() {
    // Mesma versão do "Sobre" (definida no build em vue.config.js)
    const frontendVersion = ref({ version: process.env.VUE_APP_VERSION });
    const backendVersion = ref("");

    const getBackendVersion = () => {
      versionService
        .getBackendVersion(new URLSearchParams())
        .then((resp) => {
          backendVersion.value = resp;
        })
        .catch((err) => console.log(err));
    };
    const onBackPage = () => {
      router.push(AppConstants.NAVIGATION_PAGE_HOME);
    };
    return {
      frontendVersion,
      backendVersion,
      getBackendVersion,
      onBackPage
    };
  },
};
</script>

<style>
</style>